import React, {useState, useEffect} from 'react';
import AlertDialog from "../common/AlertDialog";
import {useDispatch, useSelector} from "react-redux";
import { updateStuckCounter } from "../../redux/uiSlice";

const StuckTimerDialog = (props) => {

  const dispatch = useDispatch();
  const currentURL = window.location.pathname;
  const [dialog, setDialog] = useState(false);
  const [usedOnPrevURL, setUsedOnPrevUrl] = useState('/');
  const [triggerFlag, setTriggerFlag] = useState(false);
  const { uid } = useSelector((state) => state.user);
  const { stuckCounter, tour: isTourActive } = useSelector((state) => state.ui);


  useEffect(() => {
    let twoMinTimer;
    let shortTimer;

    if (usedOnPrevURL !== currentURL && stuckCounter < 2) {
      twoMinTimer = setTimeout(() => {
        setTriggerFlag(true);
      }, 120000);

      if (props.wrongAnswer) {
        shortTimer = setTimeout(() => {
          setTriggerFlag(true);
          clearTimeout(twoMinTimer); // this now works correctly
        }, 2500);
      }
    }

    return () => {
      clearTimeout(twoMinTimer);
      clearTimeout(shortTimer);
    };
  }, [props.wrongAnswer, currentURL, stuckCounter, usedOnPrevURL]);


  useEffect(()=> {
    if(triggerFlag && !props.complete) {
      setDialog(usedOnPrevURL !== currentURL);
      setUsedOnPrevUrl(currentURL);
    }
  },[triggerFlag]); // eslint-disable-line react-hooks/exhaustive-deps -- only on triggerFlag; URL deps would clear dialog


  const handleClose = () => {
    let newCount = stuckCounter + 1;
    dispatch(updateStuckCounter({
      uid: uid,
      stuckCounter: newCount,
    }));
    setDialog(false)
  };

  const listStyle={ margin: '10px 0'};

  if (isTourActive) return null;

  return (
    <AlertDialog open={dialog} close={handleClose}
                 title={'🤔 Stuck?'}
                 body={(<div>
                   <span style={{fontWeight: 'bold'}}>Everything can be solved through observation.</span> Try to:
                   <ul>
                     <li style={listStyle}>Walk around the location</li>
                     <li style={listStyle}>Re-read the question</li>
                     <li style={listStyle}>Talk about theories with your team</li>
                     <li style={listStyle}>Use a hint! They're meant to be used</li>
                   </ul>
                   If you've tried all of the above, skip the question. Keep things moving and fun!
                 </div>)}
                 disableCancel
                 rightButtonText={'Got it!'}
    />
  )
};

export default StuckTimerDialog;